import Vue from "vue";
import Router from "vue-router";
import store from "./store/index";
import Billing from "./views/Billing";
import Checkout from "./views/Checkout";
import Login from "./views/Login";
import AdviceList from "./views/AdviceList";
import GRNList from "./views/GRNList";
import AdviceDetails from "./views/AdviceDetails";
import GRNDetails from "./views/GRNDetails";
import GenerateGRN from "./views/GenerateGRN";
import Invoices from "./views/Invoices";
import OrderCompleted from "./views/OrderCompleted";
import ReturnItems from "./views/ReturnItems";
import HeldBill from "./views/HeldBill";
import ReturnConfirmation from "./views/ReturnConfirmation";
import ReturnSuccesfull from "./views/ReturnSuccesfull";
import adHocGrn from "./views/AdHocGRN";
import Settings from "./views/Settings";
import LicenceKey from "./views/LicenceKey";
import Loyalty from "./views/Loyalty";
import CashManagement from "./views/CashManagement";
import Customers from "./views/Customers";
import StockAudit from "./views/StockAudit";
import StockCountAudit from "./views/StockCountAudit";
import StockCount from "./views/StockCount";
import CustomersDetails from "./views/CustomersDetails";
import OrderManagement from "./views/OrderManagement";
import BatchSummary from "./views/BatchSummary";
import OrderConfirmation from "./views/OrderConfirmation";
import OrderPacking from "./views/OrderPacking";
import GiftVouchers from "./views/GiftVouchers";
Vue.use(Router);
let router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: "/",
      name: "login",
      component: Login,
    },
    {
      path: "/register",
      name: "register",
      component: LicenceKey,
    },
    {
      path: "/billing",
      name: "billing",
      component: Billing,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/checkout",
      name: "billing/checkout",
      component: Checkout,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/advice-list",
      name: "inventory/advicelist",
      component: AdviceList,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/grn-list",
      name: "inventory/grnlist",
      component: GRNList,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/advice-details/:id",
      name: "inventory/advicedetails",
      props: true,
      component: AdviceDetails,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/grn-detail/:grn_no",
      name: "inventory/grndetails",
      props: true,
      component: GRNDetails,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/generate-grn/:id",
      name: "inventory/generate-grn",
      props: true,
      component: GenerateGRN,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/invoices-history/",
      name: "invoices",
      component: Invoices,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/order-summary/:order_id/:order_from?",
      name: "invoices/order-completed",
      props: true,
      component: OrderCompleted,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/gift-vouchers",
      name: "gift-vouchers",
      component: GiftVouchers,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/return-items",
      name: "invoices/return-items",
      component: ReturnItems,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/return-confirmation",
      name: "invoices/return-confirmation",
      component: ReturnConfirmation,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/held-bill",
      name: "held-bill",
      component: HeldBill,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/return-successfull",
      name: "invoices/return-successfull",
      component: ReturnSuccesfull,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/adhoc-grn",
      name: "inventory/adhoc-grn",
      component: adHocGrn,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/stock-audit",
      name: "inventory/stock-audit",
      component: StockAudit,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/stock-count-audit",
      name: "inventory/stock-count-audit",
      component: StockCountAudit,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/stock-count",
      name: "inventory/stock-count",
      component: StockCount,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/cash-management",
      name: "cash-management",
      component: CashManagement,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/customer-list",
      name: "customer-list",
      component: Customers,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/customer-list/:mobile",
      name: "customer-list/customer-details",
      props: true,
      component: CustomersDetails,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/settings",
      name: "settings",
      component: Settings,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/loyalty",
      name: "loyalty",
      component: Loyalty,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/order-management",
      name: "order-management",
      component: OrderManagement,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/batch-summary",
      name: "batch-summary",
      component: BatchSummary,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/order-confirmation/:order_id",
      name: "order-confirmation",
      props: true,
      component: OrderConfirmation,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/order-packing/:order_id",
      name: "order-packing",
      props: true,
      component: OrderPacking,
      meta: {
        requiresAuth: true,
      },
    },
  ],
});
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    next("/");
  } else {
    next();
  }
});
export default router;